export default __webpack_public_path__ + "static/rui2-37cd7020b37e982ddeea20af668eb5d9.jpg";